import get from 'lodash/get';
import { useQuery, useApolloClient } from '@apollo/client/react';
import { MeDocument, Role, type MeQuery } from 'graphql/generated/graphql';
import requireValue from 'utils/requireValue';
import { afterLogout } from './auth/useLogout';

export default function useUser() {
  const { loading, error, data, refetch } = useQuery(MeDocument);
  const client = useApolloClient();

  const noRoles: Role[] = [];
  const roles = get(data, 'me.roles', noRoles);

  // Roles that are null (the schema allows it) make `roles.includes` throw, as they did.
  if (data?.me && !requireValue(roles, 'includes').includes(Role.admin)) {
    afterLogout(client);
  }

  const result: [MeQuery['me'] | undefined, boolean, typeof error, typeof refetch] = [
    data?.me,
    loading,
    error,
    refetch,
  ];
  return result;
}
